import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@sib/api';
import { i18n } from '@sib/i18n';
import { NotificationProvider } from '@sib/notifications';
import { TooltipProvider } from '@sib/ui';
import '@sib/ui/styles';
import { NavigationContextProvider } from '@spendbrain/common';
import { ThemeProvider } from './providers/theme-provider';
import { Router } from './router';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <NotificationProvider>
        <QueryClientProvider>
          <BrowserRouter>
            <NavigationContextProvider>
              <ThemeProvider>
                <TooltipProvider
                  delayDuration={0}
                  skipDelayDuration={0}
                  disableHoverableContent={true}
                >
                  <Router />
                </TooltipProvider>
              </ThemeProvider>
            </NavigationContextProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </NotificationProvider>
    </I18nextProvider>
  );
}

export default App;
